import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {AngularSvgIconModule} from 'angular-svg-icon';

import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTabsModule} from '@angular/material/tabs';
import {DxDataGridModule, DxTreeViewModule, DxListModule, DxContextMenuModule, DxSortableModule} from 'devextreme-angular';

import {ConfiguracionRHRoutingModule} from './configuracionrh-routing.module';
import {ComponentesModule} from '@componentes/Componentes.module';
import {GlobalModule} from '@contenido/AppContent/global/global.module';
import {PipesModule} from '@pipes/Pipes.module';

import {TipodepartamentoComponent} from './tipodepartamento/tipodepartamento.component';
import {OrganizacionComponent} from './organizacion/organizacion.component';
import {ColaboradorComponent} from './colaborador/colaborador.component';
import {ColaboradorLayoutComponent} from './colaborador/layout/colaborador_layout.component';
import {ColaboradorFormComponent} from './colaborador/colaboradorForm.component';
import {ColaboradorGeneralComponent} from './colaborador/seccion/colaborador_general.component';
import {ColaboradorHorarioComponent} from './colaborador/seccion/colaborador_horario.component';
import {ColaboradorEstudioComponent} from './colaborador/seccion/colaborador_estudio.component';
import {ColaboradorPuestoComponent} from './colaborador/seccion/colaborador_puesto.component';

@NgModule({
    imports: [
        CommonModule,
        ComponentesModule,
        GlobalModule,
        FormsModule,
        TranslateModule,
        MatTooltipModule,
        MatTabsModule,
        DxDataGridModule,
        DxTreeViewModule,
        DxListModule,
        DxContextMenuModule,
        DxSortableModule,
        AngularSvgIconModule,
        PipesModule,
        ConfiguracionRHRoutingModule
    ],
    declarations: [
        TipodepartamentoComponent,
        OrganizacionComponent,
        ColaboradorComponent,
        ColaboradorLayoutComponent,
        ColaboradorFormComponent,
        ColaboradorGeneralComponent,
        ColaboradorHorarioComponent,
        ColaboradorEstudioComponent,
        ColaboradorPuestoComponent
    ],
    entryComponents: [
        ColaboradorLayoutComponent,
        ColaboradorFormComponent
    ]
})
export class ConfiguracionRHModule {}
